// Colours shared by the hand-rolled SVG charts so axis text, gridlines and
// series strokes stay one palette.
export const CHART_SERIES_COLOR = '#0ea5e9'
export const CHART_SERIES_FILL = 'rgba(14,165,233,0.15)'
export const CHART_AXIS_LABEL_FILL = 'rgba(255,255,255,0.6)'
export const CHART_GRID_STROKE = 'rgba(255,255,255,0.08)'
export const CHART_EMPHASIS_FILL = 'rgba(255,255,255,0.85)'
export const CHART_MUTED_FILL = 'rgba(255,255,255,0.35)'
export const CHART_CROSSHAIR_STROKE = 'rgba(255,255,255,0.4)'
export const CHART_OVERLAY_DASH = '4 3'
